document.addEventListener( 'DOMContentLoaded', function () {
	const ctaPopupLink = document.querySelector( '.site-header__cta-menu .menu-item > a' );
	const ctaPopup = ctaPopupLink && ctaPopupLink.nextElementSibling && ctaPopupLink.nextElementSibling.classList.contains( 'sub-menu' )
		? ctaPopupLink.nextElementSibling
		: null;

	if ( ctaPopup ) {
		const nestedLi = ctaPopup.querySelector( 'li' );
		const closeButton = document.createElement( 'button' );
		closeButton.textContent = '×';
		closeButton.classList.add( 'sub-menu__close-button' );

		closeButton.addEventListener( 'click', () => {
			ctaPopup.classList.remove( 'sub-menu--show' );
		} );

		if ( nestedLi ) {
			nestedLi.appendChild( closeButton );
		}

		ctaPopupLink.addEventListener( 'click', function ( event ) {
			event.preventDefault();
			ctaPopup.classList.toggle( 'sub-menu--show' );
		} );
	}
} );
